import React from 'react';
import { Tile, List, ListItem } from '@op/opds.opux';
import { space } from '@op/opds.tokens';
import { Office } from '../utils/types';

interface SearchResultsProps {
  officeResults?: Office[];
  onSelectOffice: (
    branchNumber: string,
    branchOrganizationIdentificationNumber: string
  ) => void;
}

export const SearchResults: React.FC<SearchResultsProps> = ({
  officeResults,
  onSelectOffice
}) => {
  return (
    <Tile wrapContent={false}>
      <List
        border="inside"
        indented
        stacked
        style={{
          margin: 0,
          paddingBottom: space.xxs,
          paddingTop: space.xxs
        }}
      >
        {officeResults?.map((office: Office) => (
          <ListItem
            className="search-results-listitem"
            onClick={() => {
              onSelectOffice?.(
                office.branchNumber,
                office.branchOrganizationIdentificationNumber
              );
            }}
            style={{ cursor: 'pointer' }}
            key={office.branchNumber}
            title={
              <span style={{ fontWeight: 550 }}>
                {office.bankName}, {office.branchName}
              </span>
            }
          >
            {office.streetAddress}, {office.postalCode} {office.postOffice}
          </ListItem>
        ))}
      </List>
    </Tile>
  );
};
